import { cn } from "@/lib/utils";

/*
  The mark from kvinnheradelektro.no, redrawn as vectors: a socket face in the
  company's lime green with two pins, four small lugs and an indicator dot.
  Used by the /gammel variant of the site.
*/
export const GammelMark = ({ className = "", title = "Kvinnherad Elektro", ...rest }) => (
  <svg
    viewBox="0 0 64 72"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("shrink-0", className)}
    role={title ? "img" : undefined}
    aria-label={title || undefined}
    aria-hidden={title ? undefined : true}
    {...rest}
  >
    <circle cx="32" cy="5" r="4.2" fill="currentColor" />
    <rect x="27.5" y="11" width="9" height="9" rx="2.5" fill="currentColor" />
    <rect x="10" y="20" width="44" height="44" rx="15" fill="none" stroke="currentColor" strokeWidth="8" />
    <rect x="1.5" y="35" width="7" height="12" rx="3" fill="currentColor" />
    <rect x="55.5" y="35" width="7" height="12" rx="3" fill="currentColor" />
    <rect x="27.5" y="63" width="9" height="9" rx="2.5" fill="currentColor" />
    <circle cx="32" cy="35.5" r="5" fill="currentColor" />
    <circle cx="32" cy="48.5" r="5" fill="currentColor" />
  </svg>
);

/* "Kvinnherad" heavy, "elektro" regular, as on the current site. Blue on light, white on dark. */
export const GammelWords = ({ light = false, className = "" }) => (
  <span className={cn("whitespace-nowrap leading-none tracking-[-0.035em]", light ? "text-white" : "text-brand", className)} style={{ fontFamily: '"Open Sans", "Geist", sans-serif' }}>
    <span className="font-extrabold">Kvinnherad</span>
    <span className="ml-[0.18em] font-normal">elektro</span>
  </span>
);
